import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

/**
 * Section "Comparatif Budget" - Mode Pro uniquement.
 * Affiche les budgets actuel vs futur ainsi que l'écart.
 */
const ComparatifSection = ({
  budgetActuel,
  budgetFutur,
  ecart,
  ecartPourcent,
  gainEffacementApplique,
  gainEnergyManager,
  formatNumber,
}) => {
  // Helpers pour éviter les ternaires imbriqués sur l'écart
  let ecartClass = '';
  let ecartIcon = <Minus size={20} />;
  let ecartStatus = 'Budget stable';
  if (ecart > 0) {
    ecartClass = 'negative';
    ecartIcon = <TrendingUp size={20} />;
    ecartStatus = 'Augmentation';
  } else if (ecart < 0) {
    ecartClass = 'positive';
    ecartIcon = <TrendingDown size={20} />;
    ecartStatus = 'Économie';
  }

  return (
    <section className="card comparatif-card" data-testid="comparatif-section">
      <h2 className="section-title centered">Comparatif Budget</h2>
      <div className="comparatif-grid">
        <div className="budget-box" data-testid="budget-actuel-box">
          <span className="budget-label">Budget Actuel</span>
          <span className="budget-value">{formatNumber(budgetActuel)} €</span>
        </div>
        <div className="budget-box" data-testid="budget-futur-box">
          <span className="budget-label">Budget Futur</span>
          <span className="budget-value">{formatNumber(budgetFutur)} €</span>
          {gainEffacementApplique > 0 && (
            <span className="budget-detail-effacement">
              (incl. gain effacement: -{formatNumber(gainEffacementApplique)} €)
            </span>
          )}
          {gainEnergyManager > 0 && (
            <span className="budget-detail-energy-manager">
              (incl. optimisation Energy Manager -5%: -{formatNumber(gainEnergyManager)} €)
            </span>
          )}
        </div>
        <div
          className={`budget-box ecart-box ${ecartClass}`}
          data-testid="ecart-box"
        >
          <span className="budget-label">Écart</span>
          <span className="budget-value">
            {ecartIcon}
            {ecart > 0 ? '+' : ''}{formatNumber(ecart)} €
          </span>
          <span className="ecart-percent">({ecart > 0 ? '+' : ''}{ecartPourcent.toFixed(2)}%)</span>
          <span className="ecart-status">{ecartStatus}</span>
        </div>
      </div>

      <p className="info-text">Les calculs sont mis à jour en temps réel</p>
      <p className="disclaimer-text">
        Les chiffres annoncés sont purement estimatifs et doivent être validés par une étude approfondie.
      </p>
    </section>
  );
};

export default ComparatifSection;
